import { render } from "./Credits.vue?vue&type=template&id=c83a8b5e&scoped=true"
const script = {}

import "./Credits.vue?vue&type=style&index=0&id=c83a8b5e&scoped=true&lang=css"

import exportComponent from "/root/mentoringplatform-acm/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c83a8b5e"]])

export default __exports__